import { SET_CATALOG } from '@constants/actionType'

const initialState = {
  categoriesSectionCatalog: [],
  languagesCatalog: [],
  countriesCatalog: [],
  workstationCatalog: [],
  profileCatalog: [],

  tabsLanguageCatalog: [],
  itemsLanguageCatalog: [],
  keysLanguageCatalog: [],
  countriesCurrentCatalog: [],
  workstationsCurrentCatalog: [],
  sectionTreeCurrentCatalog: {},

  transactionNameCatalog: []
}

function catalogs(state = initialState, actions) {
  switch (actions.type) {
    case SET_CATALOG:
      return { ...state, [actions.payload.nameCatalog]: actions.payload.data }
    default:
      return state
  }
}

export default catalogs